import React, { Fragment, useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import { closeOrderPopUp } from "../../action/hCommerce2";
import { getDefaultAnalyticsLabel } from "../../JS/utility";
import { sendAnalytics } from "../../../action/homeAction";
import { CMSPath } from "../../../config/constant";
import Loader from "../../UI/loader";
import SpaBooking3a from "./spaBooking3a";
import SpaBooking3b from "./spaBooking3b";
import SpaBooking3summary from "./spaBooking3summary";
import SpaBooking3c from "./spaBooking3c";
import { updateMySpaBooking } from "../../../action/spaBooking";
import SpaBooking3d from "./SpaBooking3d";
import {
  searchSpaAvailability,
  makeSpaBooking,
} from "../../../action/spaBooking";
import moment from "moment";
import { scrollToTop } from "../../../JS/scrollToTop";

export const formatDateAsDateFormat = (date, format) => {
  console.log("props.dateFormat", format);

  if (!date || date == null) {
    return;
  }

  const dateObj = moment(date);
  return dateObj.format(
    `${format && format != "null" ? format.toUpperCase() : "YYYY-MM-DD"}`
  );
};

const SpaBooking3 = (props) => {
  const { t } = props;
  let label = getDefaultAnalyticsLabel({
    appVersion: props.installedAppVersion
      ? `${props.installedAppVersion}(${props.installedAppBuildNo})`
      : "",
  });
  let widgetSesstionId = localStorage.getItem("spaBookingSessionToken");

  const [loading, setLoading] = useState(false);
  const [displayLoadingMsg, setDisplayLoadingMsg] = useState("");
  const [currentPage, setCurrentPage] = useState(2);
  const [preferences, setPreferences] = useState({});
  const [additionalDetails, setAdditionalDetails] = useState({
    "email": "",
    "mobileNumber": "",
    "guestNotes": ""
  });

  const [technicianAvailableData, setTechnicianAvailableData] = useState([]);
  const [selectedTechnicianDetails, setSelectedTechnicianDetails] =
    useState(null);

  const handleSelectServiceDetailsNext = (selectedServiceDetails) => {
    // setServiceDetails({ ...serviceDetails, selectedServiceDetails });

    // setPreferredGender(selectedServiceDetails.requestedType);
    setPreferences({ dateTime: selectedServiceDetails.dateTime, gender: selectedServiceDetails.requestedType })

    let searchAvailabilityPayload = {
      "serviceType": "spa",
      dateTime: selectedServiceDetails.dateTime,
      serviceId: [+props.selectedService.service.id],
      spaLocationId: props.spaLocationId,
      requestedType: selectedServiceDetails.requestedType,
    };
    console.log("payload of availabily post api", searchAvailabilityPayload);

    setLoading(true);
    setDisplayLoadingMsg("Fetching availability...");
    console.log(searchAvailabilityPayload, "searchAvailabilityPayload");
    // const res= sample_resp
    // console.log(res.payload.data[0].availabilityData,'res.payload.data[0].availabilityData')
    // setTechnicianAvailableData(res.payload.data[0].availabilityData)

    //         setCurrentPage(3)
    //         setLoading(false);

    searchSpaAvailability(searchAvailabilityPayload)
      .then((res) => {
        setLoading(false);

        
        if (res.status == 200 && (res && res.data && res.data.header && res.data.header.status && res.data.header.status.code == "SUCCESS")) {
          setTechnicianAvailableData(
            res.data.payload.data.reduce((acc, curr) => {
              curr.availabilityData.forEach((d) => {
                acc.push(d);
              });
              return acc;
            }, [])
          );
          setCurrentPage(3);

          props.sendAnalytics(
            props.guestDetail,
            props.currentWidgets.widgetType,
            "FETCH SPA TECHNICIAN - SUCCESS",
            {
              ...label,
              layoutTab: props.currentHomePage.tabName,
              element: "widget",
              widgetSessionId: widgetSesstionId,
            },
            0,
            props.guestIsLoggedIn
          );
        }else{
          props.closeOrderPopUp(
            true,
            res && res.response && res.response.data && res.response.data.header && res.response.data.header.status && res.response.data.header.status.msg,
            "",
            true
          );

          props.sendAnalytics(
            props.guestDetail,
            props.currentWidgets.widgetType,
            "FETCH SPA TECHNICIAN - ERROR",
            {
              ...label,
              layoutTab: props.currentHomePage.tabName,
              element: "widget",
              widgetSessionId: widgetSesstionId,
              errorStatus: (res && res.response)?res.response.status:"",
              errorMessage: JSON.stringify(
                res && res.response && res.response.data && res.response.data.header && res.response.data.header.status && res.response.data.header.status.msg,
              ),
            },
            0,
            props.guestIsLoggedIn
          );
        }
      })
      .catch((err) => {
        setLoading(false);
        props.closeOrderPopUp(true, t("spaBooking.errors.error"), "", true);
      });
  };

  const handleMakeReservation = async (payload) => {
    console.log("payload of makeresevation api", payload);
    // const { data } = await makeSpaBooking(payload);
    // props.handleReservationSuccess(fakeResReservation)

    setLoading(true);
    setDisplayLoadingMsg("Making your reservation...");

    makeSpaBooking(payload)
      .then((res) => {
        setLoading(false);

        if (res.status != 200 || ((res && res.data && res.data.header && res.data.header.status && res.data.header.status.code) != "SUCCESS")) {
          props.closeOrderPopUp(true,
            res && res.data && res.data.header && res.data.header.status && res.data.header.status.msg || t("spaBooking.errors.error"),
            "", true);

          props.sendAnalytics(
            props.guestDetail,
            props.currentWidgets.widgetType,
            "Make SPA RESERVATION - ERROR",
            {
              ...label,
              layoutTab: props.currentHomePage.tabName,
              element: "widget",
              widgetSessionId: widgetSesstionId,
              errorStatus: (res && res.response)?res.response.status:"",
              errorMessage: JSON.stringify(
                res && res.response && res.response.data && res.response.data.header && res.response.data.header.status && res.response.data.header.status.msg,
              ),
            },
            0,
            props.guestIsLoggedIn
          );
        } else {
          props.handleReservationSuccess(res.data);

          props.sendAnalytics(
            props.guestDetail,
            props.currentWidgets.widgetType,
            "Make SPA RESERVATION - SUCCESS",
            {
              ...label,
              layoutTab: props.currentHomePage.tabName,
              element: "widget",
              widgetSessionId: widgetSesstionId,
            },
            0,
            props.guestIsLoggedIn
          );
        }
      })
      .catch((err) => {
        setLoading(false);
        props.closeOrderPopUp(true, t("spaBooking.errors.error"), "", true);
      });
  };

  const handleUpdateReservation = async (payload) => {
    console.log("payload of updateresevation api", payload);
    // props.handleReservationSuccess(fakeResReservation)

    setLoading(true);
    setDisplayLoadingMsg("Updating your reservation...");

    updateMySpaBooking(payload)
      .then((res) => {
        setLoading(false);

 
        if ((res.status == 200) && ((res && res.data && res.data.header && res.data.header.status && res.data.header.status.code) == "SUCCESS") && 
        ((res && res.data && res.data.payload && res.data.payload.data && res.data.payload.data.appointmentId)
          == payload.appointmentId)){

          props.handleReservationUpdateSuccess(res.data);

          props.sendAnalytics(
            props.guestDetail,
            props.currentWidgets.widgetType,
            "UPDATE SPA RESERVATION - SUCCESS",
            {
              ...label,
              layoutTab: props.currentHomePage.tabName,
              element: "widget",
              widgetSessionId: widgetSesstionId,
            },
            0,
            props.guestIsLoggedIn
          );

        }else{

          props.closeOrderPopUp(true,
            res && res.response && res.response.data && res.response.data.header && res.response.data.header.status && res.response.data.header.status.msg,
            "", true);

          props.sendAnalytics(
            props.guestDetail,
            props.currentWidgets.widgetType,
            "UPDATE SPA RESERVATION - ERROR",
            {
              ...label,
              layoutTab: props.currentHomePage.tabName,
              element: "widget",
              widgetSessionId: widgetSesstionId,
              errorStatus: (res && res.response)?res.response.status:"",
              errorMessage: JSON.stringify(
                res && res.response && res.response.data && res.response.data.header && res.response.data.header.status && res.response.data.header.status.msg
              ),
            },
            0,
            props.guestIsLoggedIn
          );
        }

      })
      .catch((err) => {
        setLoading(false);
        props.closeOrderPopUp(true, t("spaBooking.errors.error"), "", true);
      });
  };

  const handleGoBack = () => {
    console.log("handleGoBack called,currentPage:", currentPage);

    if (currentPage == 5) {
      setCurrentPage(4);
      return;
    }

    if (currentPage == 4) {
      setCurrentPage(3);
      return;
    }

    if (currentPage == 3) {
      setSelectedTechnicianDetails(null);
      console.log("happening 3");
      setCurrentPage(2);
      return;
    }


    setPreferences({});
    setTechnicianAvailableData([]);

    props.goBack();
  };
  const handleNextToAdditionalInfo = (details) => {
    console.log(details, "spabookng details");
    setCurrentPage(4);
  };
  const handleNextToSummaryPage = () => {
    setCurrentPage(5);
  };

  useEffect(() => {
    if (!loading) setDisplayLoadingMsg("");
  }, [loading]);

  useEffect(() => {
    scrollToTop();
    console.log("inside grouped - sb3", props);
    if (!props.spaLocationId || !props.selectedService) {
      props.closeOrderPopUp(
        true,
        t("spaBooking.errors.no_data_found"),
        "",
        true
      );
      props.goBack();

      return;
    }
  }, []);

  useEffect(() => {
    console.log(technicianAvailableData, "technicial data ava.");
  }, [technicianAvailableData]);



  return (
    <Fragment>

      <header className="inner-pages w-footer subpages">
        <a className="button-back" onClick={() => handleGoBack()}></a>
        <div className="heading align-center">
          <div class="splash-brand">
            <img src={`${CMSPath}${props.logo}`} />
          </div>
        </div>
      </header>

      {currentPage == 2 && (
        <SpaBooking3b
          selectedService={props.selectedService}
          updateReservationDetails={props.updateReservationDetails}
          next={(serviceDetails) =>
            handleSelectServiceDetailsNext(serviceDetails)
          }
          preferences={preferences}
          availableAddOns={props.availableAddOns}
          selectedAddon={props.selectedAddon}
          setSelectedAddon={props.setSelectedAddon}
          goBack={() => handleGoBack()}
        />
      )}
      {currentPage == 3 && (
        <SpaBooking3c
          technicianAvailableData={technicianAvailableData}
          handleNextToAdditionalInfo={handleNextToAdditionalInfo}
          selectedTechnicianDetails={selectedTechnicianDetails}
          setSelectedTechnicianDetails={setSelectedTechnicianDetails}
          goBack={() => {
            handleGoBack();
          }}
        />
      )}
      {currentPage == 4 && (
        <SpaBooking3d
          handleNextToSummaryPage={handleNextToSummaryPage}
          additionalDetails={additionalDetails}
          setAdditionalDetails={setAdditionalDetails}
          isAnyPrevReservForAnyLocation={props.isAnyPrevReservForAnyLocation}
          updateReservationDetails={props.updateReservationDetails}
          goBack={() => {
            handleGoBack();
          }}
        />
      )}

      {currentPage == 5 && (
        <SpaBooking3summary
          additionalDetails={additionalDetails}
          selectedServiceId={props.selectedService ? props.selectedService.service.id :undefined}
          selectedService={props.selectedService}
          technicianAvailableData={technicianAvailableData}
          selectedTechnicianDetails={selectedTechnicianDetails}
          spaLocationId={props.spaLocationId}
          preferences={preferences}
          chargesDetails={props.chargesDetails}
          selectedAddon={props.selectedAddon}
          
          handleMakeReservation={handleMakeReservation}
          handleUpdateReservation={handleUpdateReservation}
          updateReservationDetails={props.updateReservationDetails}
          handleBack={() => handleGoBack()}
        />
      )}
      {loading && <Loader displayMsg={displayLoadingMsg} />}
    </Fragment>

  );
};

const mapStateToProps = (state) => {
  return {
    installedAppVersion: state.store.installedAppVersion,
    installedAppBuildNo: state.store.installedAppBuildNo,
    currentHomePage: state.store2.currentHomePage,
    currentWidgetObj: state.store.sideNavBar.currentWidget,
    guestDetail: state.store.home.guestDetails,
    guestIsLoggedIn: state.store2.guestIsLoggedIn,
    currentWidgets: state.store.sideNavBar.currentWidget,
    dateFormat: state.store.home.clientConfig.extraConfigParam
      ? state.store.home.clientConfig.extraConfigParam.DATE_FORMAT
      : "",
    logo: state.store.home.currentDuration.brandingInfo
      ? state.store.home.currentDuration.brandingInfo.hotelLogoImageUrl
      : "",
  };
};

export default connect(mapStateToProps, { closeOrderPopUp, sendAnalytics })(
  withTranslation("translations")(SpaBooking3)
);
